import { render, staticRenderFns } from "./ReviewApprovalNotifications.vue?vue&type=template&id=d5e88aa6&scoped=true"
import script from "./ReviewApprovalNotifications.vue?vue&type=script&lang=js"
export * from "./ReviewApprovalNotifications.vue?vue&type=script&lang=js"
import style0 from "./ReviewApprovalNotifications.vue?vue&type=style&index=0&id=d5e88aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e88aa6",
  null
  
)

export default component.exports